import React from 'react'
import Component from 'react-component-component'
import styled from 'react-emotion'
import { Button, CancelIcon, Input } from 'stylist'
import Link from './Link'
import InputContainer from './InputContainer'
import Container from './Container'
import LabelContainer from './LabelContainer'

const PROTOCOL = 'https://'
const HTTPS = /^(https?:\/\/)/i
const WWW = /^(www.)/i
const HOSTNAME_FORMAT = /([\da-z]+)\.([\da-z]+)\.([\da-z]{2,6})/i

const isValidHostname = hostname =>
  HOSTNAME_FORMAT.test(hostname.replace(HTTPS, '').replace(WWW, ''))

const SearchBox = styled.div`
  display: flex;
`

const SearchInput = styled(Input)`
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
  flex: 1;
`

const SearchButton = styled(Button)`
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
`

const KinesisPlatformNavLink = ({ children }) => (
  <Component
    initialState={{ showInput: false, hostname: '' }}
    render={({ state: { hostname, showInput }, setState }) => (
      <Container>
        <Link
          showInput={showInput}
          onClick={() => setState({ showInput: true })}
        >
          {children}
        </Link>
        <InputContainer showInput={showInput}>
          <LabelContainer>
            <label>Panel</label>
            <CancelIcon
              cursor="pointer"
              onClick={() => setState({ showInput: false })}
              width={20}
              height={20}
            />
          </LabelContainer>
          <SearchBox>
            <SearchInput
              type="text"
              placeholder="e.g. companyname.opinioninsight.com"
              valid={true}
              onChange={e => setState({ hostname: e.target.value })}
            />
            <SearchButton
              kind="primary"
              href={PROTOCOL + hostname}
              disabled={!isValidHostname(hostname)}
              onClick={() => (window.location.href = PROTOCOL + hostname)}
            >
              Go
            </SearchButton>
          </SearchBox>
        </InputContainer>
      </Container>
    )}
  />
)

export default KinesisPlatformNavLink



// WEBPACK FOOTER //
// ./src/routes/home/components/KinesisPlatformNavLink.js